module.exports = __webpack_public_path__ + "static/media/18_A.17254fa8.png";